module.exports = __webpack_public_path__ + "img/TailWing-User.9a4cb059.jpg";